/* MolCellQuest — 学習分野の分類
   track（学習画面のタブ）→ category（セクション見出し・レーダー/バーの軸）
   問題オブジェクトの track / category はここのキーと一致していなければならない
   （tools/validate-problems.mjs が検証する）。 */

export const TRACKS = [
  { id: "genome", em: "🧬", name: "ゲノムと遺伝情報", short: "ゲノム", color: "#7bd8ff" },
  { id: "cell", em: "🔬", name: "細胞の構造と動態", short: "細胞", color: "#4fd1a5" },
  { id: "molecule", em: "⚗️", name: "分子と代謝", short: "分子", color: "#ffce5a" },
  { id: "applied", em: "🧪", name: "応用と実験", short: "応用", color: "#c9a0ff" },
];

export const CATEGORIES = [
  { id: "dna", track: "genome", em: "🧬", name: "DNA・染色体・複製・修復" },
  { id: "expression", track: "genome", em: "📜", name: "転写・RNA・翻訳" },
  { id: "regulation", track: "genome", em: "🎚️", name: "発現制御・エピジェネティクス" },

  { id: "organelle", track: "cell", em: "🫧", name: "生体膜・輸送・オルガネラ" },
  { id: "dynamics", track: "cell", em: "🕸️", name: "細胞骨格・接着・細胞運動" },
  { id: "cellcycle", track: "cell", em: "🔄", name: "細胞周期・分裂・細胞死" },
  { id: "immunity", track: "cell", em: "🛡️", name: "免疫・生体防御" },

  { id: "protein", track: "molecule", em: "🧩", name: "タンパク質・酵素" },
  { id: "metabolism", track: "molecule", em: "🔥", name: "代謝・エネルギー変換" },
  { id: "signaling", track: "molecule", em: "📡", name: "シグナル伝達・発生・がん" },

  { id: "technique", track: "applied", em: "🧪", name: "実験手法・データ解釈" },
  { id: "medicine", track: "applied", em: "💊", name: "創薬・抗体医薬・細胞工学" },
];

export const TRACK_BY_ID = Object.fromEntries(TRACKS.map((t) => [t.id, t]));
export const CATEGORY_BY_ID = Object.fromEntries(CATEGORIES.map((c) => [c.id, c]));

/** そのトラックに属するカテゴリ（定義順） */
export function categoriesOf(trackId) {
  return CATEGORIES.filter((c) => c.track === trackId);
}
